import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
export const AirFreightRateDetails = () => {
    const history = useHistory()
    const [data,] = useState(history.location.state)

    return (
        <div className="container-fluid">
            <div className="white_box h-100">
                <div className="row">
                    <div className="col-md-12 mb-4">
                        <div className="row">
                            <div className="col-md-12 my-4">
                                {/* <h3 className="mb-3 d-flex align-items-center"><b>Booking ID - {data._id}  </b>
                                    <img className="shareicon" src="/admin/assets/images/share_icon.svg" height="20" alt="" />
                                </h3> */}
                                {/* <p className="text-success">{data.airfreight_status}</p> */}
                            </div>
                            <div className="col-md-12  d-flex align-items-center" >
                                <div id="trackingSec" className="trackingSec">
                                    <div className="overflow-auto">
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Booking Confirmed</span>
                                        </div>
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Ship at warehouse</span>
                                        </div>
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Departed</span>
                                        </div>
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Arrived</span>
                                        </div>
                                        <div className="active">
                                            <span className="checkicon"></span>
                                            <span>Delivered</span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="d-flex places col-lg-10 col-12 mx-auto border align-items-center justify-content-between">
                                <div className="fromPlace">
                                    <span></span>
                                    <h5 className="mb-0"><small style={{ fontSize: '12px' }}>From</small><br />{data.origin_city_name} ( {data.origin_country_name} )</h5>
                                    {/* <p>{data.origin_coordinates}</p> */}
                                </div>
                                <div className="path flex-grow-1 text-center">
                                    <span>Courier Door to Door</span>
                                </div>
                                <div className="toPlace">
                                    <span></span>
                                    <h5 className="mb-0"><small style={{ fontSize: '12px' }}>To</small><br />{data.destination_city_name} ( {data.destination_country_name} )</h5>
                                    {/* <p>{data.origin_country_coordinates}</p> */}
                                </div>
                            </div>
                            <div className="col-12">
                                <hr />
                            </div>
                            <div className="col-md-12">
                                <div className="card p-3">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-6 border-end">

                                            <h5 className="secHeading">Sender Details</h5>
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">City Name - </td>
                                                        <td className="py-1">{data.origin_city_name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Country Name - </td>
                                                        <td className="py-1">{data.origin_country_name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">ISO 2 - </td>
                                                        <td className="py-1">{data.origin_country_iso2}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">ISO 3 - </td>
                                                        <td className="py-1">{data.origin_country_iso3}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Currency - </td>
                                                        <td className="py-1">{data.origin_country_currency}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Dial Code - </td>
                                                        <td className="py-1">{data.origin_country_dial_code}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Air Courier Available - </td>
                                                        <td className="py-1">{data.origin_air_courier_available ? 'Yes' : 'No'}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Sea Courier Available - </td>
                                                        <td className="py-1">{data.origin_sea_courier_available ? 'Yes' : 'No'}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Road Courier Available - </td>
                                                        <td className="py-1">{data.origin_road_courier_available ? 'Yes' : 'No'}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>

                                        <div className="col-lg-4 col-md-6 border-end">
                                            <h5 className="secHeading">Receiver Details</h5>
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">City Name - </td>
                                                        <td className="py-1">{data.destination_city_name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Country Name - </td>
                                                        <td className="py-1">{data.destination_country_name}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">ISO 2 - </td>
                                                        <td className="py-1">{data.destination_country_iso2}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">ISO 3 - </td>
                                                        <td className="py-1">{data.destination_country_iso3}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Currency - </td>
                                                        <td className="py-1">{data.destination_country_currency}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Dial Code - </td>
                                                        <td className="py-1">{data.destination_country_dial_code}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Air Courier Available - </td>
                                                        <td className="py-1">{data.destination_air_courier_available ? 'Yes' : 'No'}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Sea Courier Available - </td>
                                                        <td className="py-1">{data.destination_sea_courier_available ? 'Yes' : 'No'}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Road Courier Available - </td>
                                                        <td className="py-1">{data.destination_road_courier_available ? 'Yes' : 'No'}</td>
                                                    </tr>
                                                </tbody>
                                            </table>


                                        </div>
                                        <div className="col-lg-4 col-md-6">
                                            <h5 className="secHeading">Shipment Details</h5>
                                            <table width="100%">
                                                <tbody>
                                                    <tr>
                                                        <td className="py-1">+ 45 Kg - </td>
                                                        <td className="py-1">{data.amount_greater_than_45}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">+ 100 Kg - </td>
                                                        <td className="py-1">{data.amount_greater_than_100}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">+ 250 Kg - </td>
                                                        <td className="py-1">{data.amount_greater_than_250}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">+ 500 Kg - </td>
                                                        <td className="py-1">{data.amount_greater_than_500}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">+ 1000 Kg - </td>
                                                        <td className="py-1">{data.amount_greater_than_1000}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Normal Amount - </td>
                                                        <td className="py-1">{data.normal_amount}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Minimum Amount - </td>
                                                        <td className="py-1">{data.minimum_amount}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Door Delivery tt - </td>
                                                        <td className="py-1">{data.door_delivery_tt}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Port Delivery tt - </td>
                                                        <td className="py-1">{data.port_delivery_tt}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="py-1">Fuel -</td>
                                                        <td className="py-1">{data.fuel}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div>
        </div>

    )
}